import isProd from '../constants/isProd'
import search_params from '../../data/search_params.json'

const searchParams = isProd ? window.search_params : search_params

export default searchParams
